import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";

// import { Table } from "antd";
import { getMedicalTestDetails } from "../../connections/getMedicalTestDetails";

const ShowMedicalTest = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: medicalTestDetailsData, isLoading } = useQuery({
    queryKey: ["getMedicalTestDetails", id],
    queryFn: () => getMedicalTestDetails(user?.token, id),
    enabled: !!id,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const columns = [
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //   },
  //   {
  //     title: "Amount",
  //     dataIndex: "amount",
  //   },
  //   {
  //     title: "Discount",
  //     dataIndex: "discount",
  //   },
  //   {
  //     title: "Medical Test Category",
  //     dataIndex: "medical_test_category",
  //     render: (medical_test_category) => (
  //       <Link
  //         to={`/admin/medical_tests_category/${medical_test_category?.id}`}
  //         style={{ textDecoration: "underline" }}
  //       >
  //         {medical_test_category?.name}
  //       </Link>
  //     ),
  //   },
  //   {
  //     title: "Female",
  //     dataIndex: "female_min",
  //     render: (_, record) => (
  //       <>
  //         {record?.female_min}
  //         {"-"}
  //         {record?.female_max}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Male",
  //     dataIndex: "male_min",
  //     render: (_, record) => (
  //       <>
  //         {record?.male_min}
  //         {"-"}
  //         {record?.male_max}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Composite",
  //     dataIndex: "composite",
  //     render: (composite) => <span>{composite ? "Yes" : "No"}</span>,
  //   },
  //   {
  //     title: "Unit",
  //     dataIndex: "unit",
  //   },
  //   {
  //     title: "Cost To Lab",
  //     dataIndex: "cost_to_lab",
  //   },
  //   {
  //     title: "Active",
  //     dataIndex: "active",
  //     render: (active) => (
  //       <span
  //         className={
  //           active ? "custom-badge status-green" : "custom-badge status-pink"
  //         }
  //       >
  //         {active ? "Yes" : "No"}
  //       </span>
  //     ),
  //   },
  // ];
  return (
    <>
      <Header />
      <Sidebar activeClassName="medical-test-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Medical Test Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Medical Test Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/admin/update-medical_tests", {
                                    state: medicalTestDetailsData,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Name:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.name || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Amount:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.amount || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Discount:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.discount || "N/A"}
                                  </span>
                                </li>
                                 <li className="pb-1">
                                  <span className="title">Composite Fields:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.composite_fields?.join(", ") || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">
                                    Medical Test Category:
                                  </span>
                                  <span className="text">
                                    {medicalTestDetailsData?.medical_test_category ? (
                                      <Link
                                        to={`/admin/medical_tests_category/${medicalTestDetailsData.medical_test_category?.id}`}
                                        style={{ textDecoration: "underline" }}
                                      >
                                        {
                                          medicalTestDetailsData
                                            ?.medical_test_category?.name
                                        }
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Female:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.female_min} -{" "}
                                    {medicalTestDetailsData?.female_max ||
                                      "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Male:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.male_min} -{" "}
                                    {medicalTestDetailsData?.male_max || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Composite:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.composite
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Unit:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.unit || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Cost To Lab:</span>
                                  <span className="text">
                                    {medicalTestDetailsData?.cost_to_lab ||
                                      "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Active:</span>
                                  <span className="text">
                                    <span
                                      className={
                                        medicalTestDetailsData?.active
                                          ? "custom-badge status-green"
                                          : "custom-badge status-pink"
                                      }
                                    >
                                      {medicalTestDetailsData?.active
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="table-responsive">
                      //   <Table
                      //     columns={columns}
                      //     dataSource={[medicalTestDetailsData]}
                      //     pagination={false}
                      //     scroll={{ x: "max-content" }}
                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default ShowMedicalTest;
